import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import DataGrid from "@dtci/spellbook/DataGrid";
import styles from "../../../../components/AGGrid/details-table.module.scss";
import { UserDrawer } from "../drawer";
import { useAgGridApi } from "tap/components/AGGrid/hooks.js";
import { useUserGridUtils } from "./utils/gridUtils";
import { useUsersActions } from "tap/store/users/useUsers.js";
import { useUsersData } from "../../hooks/useUsersData";

/**
 * Users Grid - Displays users in a data grid with row click to edit.
 */
export const UsersGrid = () => {
  const agGridApi = useAgGridApi();
  const { users, refreshUsers } = useSelector((s) => s.users);
  const { updateUsers } = useUsersActions();
  const { fetchUsers, userRange, filterForm } = useUsersData();

  const { columns } = useUserGridUtils();

  const refreshUsersList = async () => {
    const data = await fetchUsers(userRange, filterForm);
    if (data) {
      updateUsers({
        users: data?.content,
        totalPages: data?.totalPages,
        totalItems: data?.totalElements,
        currentPage: data?.pageable?.pageNumber,
      });
    }
  };

  useEffect(() => {
    if (refreshUsers) {
      refreshUsersList();
      updateUsers({ refreshUsers: false });
    }
  }, [refreshUsers]);

  const onRowClicked = useCallback(
    (event) => {
      updateUsers({
        drawerMode: "edit",
        selectedUser: event.data,
      });
    },
    [updateUsers],
  );

  return (
    <>
      <DataGrid
        className={styles.dataGrid}
        autoSizing
        agGrid={{
          ref: agGridApi.AgGridApiRef,
          rowData: users ?? [],
          headerHeight: 45,
          suppressColumnStateReset: true,
          onRowClicked: onRowClicked,
          defaultColDef: {
            wrapText: true,
            autoHeight: true,
            resizable: true,
            suppressHeaderMenuButton: true,
            cellStyle: {
              paddingTop: "10px",
              paddingBottom: "10px",
              wordBreak: "break-word",
            },
          },
        }}
        bordered="none"
        columnDefs={columns}
        sortable={false}
        striped
        noResultsMessage={"No Users Found"}
      />
      <UserDrawer />
    </>
  );
};
